export default {
    name: "DeleteRow",
    title: "Delete Row",
    icon: "mdi-database-remove",
    create() {
        return {
            name: this.title,
            description: "",
            actionType: this.name,
            childAction1: [],
            childAction2: [],
            parameter1: null,
            parameter2: null,
            parameter3: null,
            parameter4: null,
            parameter5: null,
            filters: [],
            values: [],
            columns: [],
        };
    },
};